export function formatPossessive(text, locale) {
    if (!text) {
        return;
    }
    const language = locale.substr(0, 2);
    if (language === "sv") {
        return formatSwedish(text);
    }
    else if (language === "en") {
        return formatEnglish(text);
    }
    return text;
}
function formatSwedish(text) {
    if (text[text.length - 1] !== "s" &&
        text[text.length - 1] !== "z" &&
        text[text.length - 1] !== "x") {
        text += "s";
    }
    return text;
}
function formatEnglish(text) {
    if (text[text.length - 1] === "s") {
        return text + "'";
    }
    return text + "'s";
}
